<mat-drawer-container class="w-100 h-100 m-0 p-0">
  <mat-drawer-content>
    <div [formGroup]="form" class="chat px-2">
      <div class="d-flex h-100 flex-column">
        <div class="flex-fill history" #historyDiv>
          <div class="row p-0 m-0 font-monospace">
            <div>
              <div
                *ngFor="let item of localHistory"
                [ngClass]="{
                  'team':  item['sender'] == sub,
                  'customer':  item['sender'] != sub
                }"
                class="message__text last mb-3"
              >
                <div [ngClass]="{'text-end': item['sender'] == sub}" class="heading"
                >
                  <div class="d-flex justify-content-between flex-row" [ngClass]="{
                    'flex-row-reverse': item['sender'] != sub
                  }">
                    <div *ngIf="item['id']">
                      <button
                        mat-mini-fab
                        color=""
                        matTooltip="Copy the contents of this chat message"
                        (click)="copyMessage(item)"
                        [ngStyle]="{transform: 'scale(0.7)'}">
                        <mat-icon>content_copy</mat-icon>
                      </button>
                      <button
                        matTooltip="Inspect details about Retrieval Augmented Generation (RAG)"
                        mat-mini-fab
                        color=""
                        [routerLink]="[{ outlets: { sidePanel: ['inspect', item['id']]}}]"
                        [ngStyle]="{transform: 'scale(0.7)'}"
                      >
                        <mat-icon>adb</mat-icon>
                      </button>
                    </div>
                    <div>
                      <div class="fw-bold">{{item['sender']}}</div>
                      <div class="font-size-12"> {{item['timestamp'] | date: 'MMM dd HH:mm'}}</div>
                    </div>
                  </div>
                </div>
                <div class="d-block m-2 mt-4 my-form-field" [ngClass]="{'text-right': item['sender'] == 'remote'}">
                  <chat-message-node [message]="item"></chat-message-node>
                </div>
              </div>
            </div>
          </div>
          <div class="loader my-3" *ngIf="loading"></div>
        </div>
        <div class="d-block">
          <div class="d-flex">
            <div class="flex-fill pe-2">
              <mat-form-field class="d-block mb-0 pb-0 my-form-field">
                <mat-label>Prompt</mat-label>
                <textarea  cdkTextareaAutosize
                           cdkAutosizeMinRows="1"
                           cdkAutosizeMaxRows="500"
                           matInput class="d-block"
                           formControlName="prompt"></textarea>
              </mat-form-field>
            </div>
            <div>
              <button mat-fab [disabled]="loading" color="primary" (click)="submit()">
                <mat-icon>send</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
  </mat-drawer-content>
  <mat-drawer
    mode="over"
    position="end"
    [opened]="routerEvent != undefined"
    (openedChange)="onSidePanelChange($event)"
    class="message-details"
  >
    <router-outlet
      name='sidePanel'
      (activate)="routerEvent = $event"
      (deactivate)="routerEvent = undefined"
    ></router-outlet>
  </mat-drawer>
</mat-drawer-container>
